import styled from "styled-components";

export const VarianceWrapper = styled("div")(() => {
  return {
    position: "relative",
    display: "grid",
    gap: "var(--flexGap)",
    padding: 0,
    "& select": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      fontWeight: "400",
      border: "1px solid #d9dee7",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "1px solid var(--color-primary)",
      },
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
      border: "none",
      margin: 0,
      padding: 0,
    },
    "& .variance-controls": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gap: "1rem",
    },
    "& .heading": {
      padding: 0,
      "& h3": {
        margin: 0,
        color: "var(--color-text)",
      },
    },
    "& .filter": {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      padding: 0,
      alignItems: "end",
      justifyContent: "space-between",
      gap: "1rem",
      "@media screen and (max-width: 768px)": {
        flexDirection: "column",
      },
    },
    "& .export-button": {
      backgroundColor: "var(--color-primary)",
      color: "#FFFFFF",
      border: "none",
      borderRadius: "0.45rem",
      fontSize: "0.88rem",
      fontWeight: 600,
      cursor: "pointer",
      padding: "0.7rem 1.2rem",
      height: "3rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    "& .error-box": {
      display: "grid",
      gap: "1rem",
      "& p": {
        margin: 0,
        color: "#C53A2F",
        fontFamily: "Poppins",
        fontSize: "0.88rem",
        fontWeight: 500,
      },
    },
    "& .variance-report-card": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflow: "hidden",
      backgroundColor: "var(--color-neutral)",
      display: "grid",
      gap: 0,
    },
    "& .variance-table": {
      overflow: "auto",
      backgroundColor: "var(--color-neutral)",
      "& table": {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        minWidth: "950px",
      },
    },
    "& th": {
      color: "var(--color-primary)",
      backgroundColor: "var(--color-primary-hover)",
      minWidth: "150px",
      fontSize: "0.8rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontWeight: 700,
      borderBottom: "1px solid #e5e7eb",
    },
    "& td": {
      minWidth: "200px",
      color: "var(--color-text)",
      fontSize: "0.88rem",
      borderBottom: "1px solid #edf1f6",
      padding: "0.95rem 1rem",
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-neutral)",
      padding: "1rem",
      borderRadius: "0.9rem",
      boxShadow: "0px 20px 24px -4px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "0.9rem",
        border: "none",
        width: "85%",
      },
    },
    "@media screen and (max-width: 425px)": {
      "& .filter": {
        gridTemplateColumns: "1fr",
        gap: "0.75rem",
      },
      "& .filters-action-slot": {
        width: "100%",
      },
    },
  };
});
